import script from "./tree.vue?vue&type=script&lang=ts&setup=true"
export * from "./tree.vue?vue&type=script&lang=ts&setup=true"

import "./tree.vue?vue&type=style&index=0&id=1504a5b8&lang=scss"

const __exports__ = script;

export default __exports__